module.exports = __webpack_public_path__ + "img/phone.a0a26246.png";